import React, { useState, useEffect } from "react";
import "./appointment-scheduling.scss";
import { SubmitData } from "../../services/apiService";
import useAlertUtils from "../../utils/common.utils";
import Footer from "../../components/Footer/Footer";
import PreLoginHeader from "../../components/PreLoginHeader/PreLoginHeader";
import Header from "../../components/Header/Header";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import "./appointment-scheduling.scss";
import { makeDecryptionData } from "../../services/encryptionDecription.service";
import { fetchData } from "../../services/apiService";
import { CiEdit } from "react-icons/ci";

function BookingPage() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const { alertSuccess, alertError } = useAlertUtils();

  const [attendeeEmail, setAttendeeEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [userData, setUserData] = useState(null);
  const [editmail, setEditMail] = useState(false);
  const [userId, setUserId] = useState(0);

  const slotStart = queryParams.get("slotStart");
  const slotEnd = queryParams.get("slotEnd");

  const getUserData = async (decoded) => {
    try {
      const data = await fetchData(`api/users/get-user-data/${decoded.userId}`);
      if (data.success) {
        const decryptData = makeDecryptionData(data.data);
        setUserData(decryptData);
        setAttendeeEmail(decryptData.email);
        setUserId(decoded.userId);
      } else {
        alertError("Error Fetching User Data");
      }
    } catch (error) {
      alertError("Error -> ", error);
    }
  };

  useEffect(() => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => `%${("00" + c.charCodeAt(0).toString(16)).slice(-2)}`)
        .join("")
    );

    const decoded = JSON.parse(jsonPayload);
    getUserData(decoded);
  }, []);

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (!attendeeEmail) {
      alertError("Please provide an attendee's email and select a slot.");
      return;
    }

    setLoading(true);

    const payload = {
      userId: userId,
      attendeeEmail: attendeeEmail,
      slotStart: slotStart,
      slotEnd: slotEnd,
    };

    if (token) {
      try {
        const response = await SubmitData(
          "/api/appointment/book-slot",
          payload
        );
        if (response.message) {
          alertSuccess(response.message);
          setAttendeeEmail("");
          navigate(`/app/confirm-booking?id=${response.body.id}`);
        } else {
          alertError("Error booking the slot.");
          navigate("/app/available-slots");
        }
      } catch (err) {
        alertError("Failed to send data to the server.");
      } finally {
        setLoading(false);
      }
    } else {
      alertError("Please Login To Get a Slot");
      navigate("/");
    }
  };

  return (
    <div className="booking-app">
      {token ? <Header /> : <PreLoginHeader />}

      <div className="confirmation-hero">
        <div className="hero-content">
          <h1>Complete Your Booking</h1>
          <p>One last step to secure your appointment</p>
        </div>
      </div>

      <div className="confirmation-container">
        <div className="confirmation-card">
          <div className="card-decoration"></div>

          <div className="card-header">
            <div className="emoji-circle">📅</div>
            <h2>Confirm Your Appointment</h2>
            <div className="time-display">
              <div className="time-badge">
                {new Date(slotStart).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
              <div className="date-display">
                {new Date(slotStart).toLocaleDateString("en-US", {
                  weekday: "long",
                  month: "long",
                  day: "numeric",
                })}
              </div>
            </div>
          </div>

          <form onSubmit={handleFormSubmit} className="booking-form">
            <div className="names_wrapper">
              <div className="inputs-group">
                <label className="input-label">Your First Name</label>
                <div className="input-wrapper">
                  <input
                    type="text"
                    value={userData?.firstName}
                    placeholder="First Name"
                    className="input-field"
                    disabled
                  />
                </div>
              </div>
              <div className="inputs-group">
                <label className="input-label">Your Last Name</label>

                <div className="input-wrapper">
                  <input
                    type="text"
                    value={userData?.lastName}
                    placeholder="Last Name"
                    className="input-field"
                    disabled
                  />
                </div>
              </div>
            </div>
            <div className="inputs-group">
              <label className="input-label">Your Email Address</label>

              <div className="input-wrapper">
                <input
                  type="email"
                  value={attendeeEmail}
                  onChange={(e) => setAttendeeEmail(e.target.value)}
                  required
                  placeholder="example@email.com"
                  className="input-field"
                  disabled={!editmail}
                />
                <CiEdit
                  className="edit-icon"
                  onClick={() => {
                    setEditMail(true);
                  }}
                />
              </div>

              <div className="input-note">
                We'll send confirmation details here
              </div>
            </div>

            <button
              type="submit"
              className={`submit-button ${loading ? "loading" : ""}`}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Processing...
                </>
              ) : (
                <>
                  Confirm Booking
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M5 12H19M19 12L12 5M19 12L12 19"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                    />
                  </svg>
                </>
              )}
            </button>
          </form>

          <div className="confirmation-assurance">
            <div className="assurance-item">
              <div className="assurance-icon">🔒</div>
              <div className="assurance-text">Secure booking process</div>
            </div>
            {/* <div className="assurance-item">
              <div className="assurance-icon">🔄</div>
              <div className="assurance-text">Easy rescheduling</div>
            </div> */}
          </div>
        </div>

        <div className="confirmation-sidebar">
          <div className="sidebar-card">
            <h3>What to Expect</h3>
            <ul className="expectation-list">
              <li>
                <div className="expectation-icon">📧</div>
                <div className="expectation-text">
                  Instant confirmation email
                </div>
              </li>
              <li>
                <div className="expectation-icon">⏰</div>
                <div className="expectation-text">Reminder 24 hours before</div>
              </li>
              <li>
                <div className="expectation-icon">👩‍⚕️</div>
                <div className="expectation-text">Video consultation link</div>
              </li>
            </ul>
          </div>

          <div className="testimonial-card">
            <div className="testimonial-quote">
              "The booking process was seamless and the doctor was incredibly
              knowledgeable."
            </div>
            <div className="testimonial-author">- Sarah J.</div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default BookingPage;
